import { render, staticRenderFns } from "./FloatMsg.vue?vue&type=template&id=43145ef6&"
import script from "./FloatMsg.vue?vue&type=script&lang=js&"
export * from "./FloatMsg.vue?vue&type=script&lang=js&"
import style0 from "./FloatMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports